import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import SelectOption from "views/UIelems/SelectOption";
import docs_model from "models/docs_model";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
//	A doctor picker that loads its own options asynchronously, from `doc_cat` rather than the restricted `docs`
//	node. get_sel_docs_list() memoises into app.app_data.ws_data, so mounting this repeatedly costs one read.
const DocSelect = (props) => {
    const { data: options, loading, error } = useAsync(() => docs_model.get_sel_docs_list());
    return error ? (_jsxs("em", { children: ["(error loading doctors: ", error === null || error === void 0 ? void 0 : error.message, ")"] })) : (_jsx(SelectOption, Object.assign({}, props, { options: options || [], loading: loading })));
};
export default DocSelect;
